// src/utils/helpers.js

// ── Máscaras ────────────────────────────────────────────────────────────────

export const maskPhone = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').trim();
  }
  return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').trim();
};

export const maskDate = (value) => {
  return value.replace(/\D/g, '').slice(0, 8)
    .replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3').trim();
};

export const maskCPF = (value) => {
  return value.replace(/\D/g, '').slice(0, 11)
    .replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4').trim();
};

// ── Validações ──────────────────────────────────────────────────────────────

export const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isValidPhone = (phone) =>
  phone.replace(/\D/g, '').length >= 10;

// ── Datas ───────────────────────────────────────────────────────────────────

// Converte qualquer formato de data para objeto Date sem problema de fuso
const parseDate = (dateStr) => {
  if (!dateStr) return null;
  let s = String(dateStr).trim();
  // ISO com Z ou T: "2026-06-16T00:00:00.000Z" → pega só "2026-06-16"
  if (s.includes('T')) s = s.split('T')[0];
  // Formato DD/MM/YYYY (vindo do Google Sheets como texto)
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
    const [d, m, y] = s.split('/');
    return new Date(Number(y), Number(m) - 1, Number(d));
  }
  // Formato YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-');
    return new Date(Number(y), Number(m) - 1, Number(d));
  }
  return null;
};

export const calcIdade = (dataNascimento) => {
  if (!dataNascimento) return null;
  const hoje = new Date();
  const nasc = parseDate(dataNascimento);
  if (!nasc) return null;
  let anos = hoje.getFullYear() - nasc.getFullYear();
  const m = hoje.getMonth() - nasc.getMonth();
  if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) anos--;
  return anos;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = parseDate(dateStr);
  if (!d || isNaN(d)) return '—';
  return d.toLocaleDateString('pt-BR');
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d)) return '—';
  return d.toLocaleString('pt-BR');
};

export const daysBetween = (date1, date2) => {
  const a = parseDate(date1);
  const b = parseDate(date2);
  if (!a || !b) return 0;
  return Math.floor((b - a) / (1000 * 60 * 60 * 24));
};

export const today = () => new Date().toISOString().split('T')[0];

// ── Arquivos ─────────────────────────────────────────────────────────────────

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1048576).toFixed(1) + ' MB';
};

// ── Status ───────────────────────────────────────────────────────────────────

export const statusLabel = (s) => ({
  Pendente: 'Pendente',
  Aprovado: 'Aprovado',
  Reprovado: 'Reprovado',
  Concluído: 'Concluído',
}[s] || s);

export const statusClass = (s) => ({
  Pendente: 'badge-pending',
  Aprovado: 'badge-approved',
  Reprovado: 'badge-rejected',
  Concluído: 'badge-done',
}[s] || 'badge-pending');